export default __webpack_public_path__ + "static/media/colorectal2.c4374da8.jpg";